<template>
    <div id="add-service-modal" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <form class="modal-content" @submit.prevent="sendServiceData" autocomplete="off">
                <header class="modal-header">
                    <h5 class="modal-title">Добавить услугу</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </header>
                <div class="modal-body">
                    <div class="alert mb-3" :class="info ? 'alert-success alert-dismissible' : 'alert-danger'" role="alert" v-if="info || error">
                        {{ info || error }}
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" v-if="info"></button>
                    </div>
                    <div class="mb-3">
                        <label for="name-input" class="form-label">Название услуги:</label>
                        <input id="name-input" v-model.trim="newService.NAME" type="text" class="form-control" required />
                    </div>
                    <div class="mb-3">
                        <label for="obj-select" class="form-label">Объект:</label>
                        <select id="obj-select" v-model="newService.OBJ" class="form-select" required>
                            <option value="plot">Участок</option>
                            <option value="house">Дом</option>
                        </select>
                    </div>
                    <div class="mb-3">
                        <label for="meter-select" class="form-label">Измерение:</label>
                        <select id="meter-select" v-model="newService.METERING" class="form-select" required>
                            <option value="piece">Шт.</option>
                            <option value="meter">М²</option>
                            <option value="hundred">Сотки</option>
                        </select>
                    </div>
                    <div class="mb-3">
                        <label for="desc-input" class="form-label">Описание:</label>
                        <input id="desc-input" v-model.trim="newService.DESCRIPTION" type="text" class="form-control" required />
                    </div>
                    <div>
                        <label for="type-select" class="form-label">Тип услуги:</label>
                        <select id="type-select" v-model="newService.REGULAR" class="form-select" required>
                            <option value="Y">Регулярная</option>
                            <option value="N">Единоразовая</option>
                        </select>
                    </div>
                </div>
                <footer class="modal-footer justify-content-center">
                    <button type="submit" class="btn btn-primary">Создать</button>
                </footer>
            </form>
        </div>
    </div>
</template>

<script>
    import config from "@/config";

    export default {
        name: "ServicesAdd",
        modal: null,
        data() {
            return {
                url: config.backend_url,
                newService: {
                    NAME: null,
                    OBJ: null,
                    METERING: null,
                    DESCRIPTION: null,
                    REGULAR: null
                },
                info: null,
                error: null
            };
        },
        mounted: function()
        {
            //this.$options.modal = new bootstrap.Modal(this.$el);
        },
        methods: {
            setDefaultData: function ()
            {
                this.info = this.error = null;
                this.newService = {
                    NAME: null,
                    OBJ: null,
                    METERING: null,
                    DESCRIPTION: null,
                    REGULAR: null
                };
            },
            sendServiceData: function ()
            {
                this.info = this.error = null;

                this.$store
                    .dispatch("query/sendRequest", {
                        url: this.url + "services/add/",
                        data: this.newService,
                        method: "POST"
                    })
                    .then(response => {
                        let data = response.data;
                        if (data.services) {
                            this.info = "Услуга успешно добавлена";
                            this.$emit("service-add");
                            this.setDefaultData();
                        } else {
                            this.error = 'Услуга не была добавлена';
                        }
                    })
                    .catch(error => {
                        this.error = error;
                    });
            }
        }
    };
</script>
